export const selectors = {
	locationContainer: '.location--map',
	map: '.location__map',
	sidebar: '.location__sidebar',
	locationList: '.location__list',
	locationListMobile: '.location__list--mobile',
	locationSlider: '.location-slider',
	sliderBtnPrev: '.location-slider__btn--prev',
	sliderBtnNext: '.location-slider__btn--next',
	paginationBullet: '.location__pagination-bullet',
};

export const classes = {
	active: 'tile--active',
	paginationBullet: 'location__pagination-bullet',
};
